import {
    Box,
    Container,
    Grid,
    Link,
    List,
    ListItem,
    ListItemText,
    Typography,
} from "../../../../components/ui/LayoutPrimitives";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllProducts } from "../../../../api/action/products";
import SocialIcons from "../../../../assets/SocialIcons";

const TealFlowTemplateFooter = ({ company }) => {
    const companyState = useSelector((state) => state.companyReducer.company);
    const companyPrimaryId = companyState?.primaryId;
    const companyOperatingLocation = companyState?.operatingLocation?.code;
    const phoneNumber = company?.contactPerson?.phoneNumber || "(678) 855-6990";
    const code = companyOperatingLocation || "";
    function assignCountryCode(code) {
        return code === "IND" ? "+91" : "+1";
    }

    const countryCode = assignCountryCode(code);
    const dispatch = useDispatch();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                if (!companyPrimaryId) return;
                const response = await getAllProducts(companyPrimaryId)(dispatch);
                const uniqueCategories = [...new Set(response.map((product) => product.category.name))];
                setCategories(uniqueCategories.slice(0, 6));
            } catch {
                setCategories([]);
            }
        };

        fetchProducts();
    }, [companyPrimaryId, dispatch]);

    const shouldDisplayOnlineShopping = categories.length > 0;

    return (
        <>
            {localStorage.getItem("domainType") !== "ASSESSMENT" && (
                <Box
                    component="footer"
                    sx={{
                        bgcolor: "#006666", // Darker teal background
                        color: "white",
                        py: 6,
                        textTransform: "capitalize",
                        mt: 8,
                    }}
                >
                    <Container maxWidth="xl">
                        <Grid container spacing={4}>
                            {shouldDisplayOnlineShopping && (
                                <Grid item xs={12} sm={6} md={3}>
                                    <Box p={3}>
                                        <Typography variant="h6" sx={{ fontWeight: "bold", color: "#66b2b2" }}>
                                            Online Shopping
                                        </Typography>
                                        <List>
                                            {categories.map((category, index) => (
                                                <ListItem key={index} disableGutters>
                                                    <ListItemText
                                                        primary={
                                                            <Link
                                                                href="#"
                                                                underline="hover"
                                                                sx={{
                                                                    color: "white",
                                                                    "&:hover": { color: "#66b2b2" },
                                                                }}
                                                            >
                                                                {category}
                                                            </Link>
                                                        }
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                </Grid>
                            )}
                            <Grid item xs={12} sm={6} md={3}>
                                <Box p={3}>
                                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#66b2b2" }}>
                                        Useful Links
                                    </Typography>
                                    <List>
                                        {["Blog", "Careers", "Site Map", "Corporate Information", "Whitehat", "Cleartrip"].map((text) => (
                                            <ListItem key={text} disableGutters>
                                                <ListItemText
                                                    primary={
                                                        <Link
                                                            href="#"
                                                            underline="hover"
                                                            sx={{
                                                                color: "white",
                                                                "&:hover": { color: "#66b2b2" },
                                                            }}
                                                        >
                                                            {text}
                                                        </Link>
                                                    }
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box p={3}>
                                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#66b2b2" }}>
                                        Customer Policies
                                    </Typography>
                                    <List>
                                        {[
                                            { text: "Terms Of Use", link: "/termsConditions" },
                                            { text: "Privacy Policy", link: "/privacyPolicy" },
                                            { text: "User Acceptance", link: "/userAcceptance" },
                                            { text: "Cookies", link: "/cookies" },
                                            { text: "FAQ", link: "#" },
                                        ].map((item) => (
                                            <ListItem key={item.text} disableGutters>
                                                <ListItemText
                                                    primary={
                                                        <Link
                                                            href={item.link}
                                                            underline="hover"
                                                            sx={{
                                                                color: "white",
                                                                "&:hover": { color: "#66b2b2" },
                                                            }}
                                                        >
                                                            {item.text}
                                                        </Link>
                                                    }
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3}>
                                <Box p={3}>
                                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "#66b2b2" }}>
                                        Keep In Touch
                                    </Typography>
                                    <SocialIcons />
                                    <Typography
                                        variant="body1"
                                        sx={{ mt: 2, color: "white" }}
                                    >
                                        <Link
                                            href={"tel:" + phoneNumber}
                                            underline="hover"
                                            sx={{ color: "white", "&:hover": { color: "#66b2b2" } }}
                                        >
                                            {countryCode} {phoneNumber}
                                        </Link>
                                        <br />
                                        <Link
                                            href={"mailto:" + (company?.contactPerson?.email || "system@avpstech.com")}
                                            underline="hover"
                                            sx={{ color: "white", "&:hover": { color: "#66b2b2" } }}
                                        >
                                            {company?.contactPerson?.email || "system@avpstech.com"}
                                        </Link>
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
            )}
        </>
    );
};

export default TealFlowTemplateFooter;
